<template>
  <div>
    <div class="vx-row company-room">
      <div id="meet" class="w-1/2 vx-col confroom"></div>
      <div class="vx-col w-1/3">
        <div class="dialer">
          <form method="post" v-on:submit.prevent="$event.preventDefault()">
            <div class="vx-row">
              <div class="vx-col mt-5 ml-10 w-1/2 dialer_number">
                <vue-tel-input
                  size="large"
                  v-validate="{required: true, regex:/^(?=.*[0-9])[- +()0-9]+$/,min:12}"
                  v-model="dialer_number"
                  v-bind="bindProps"
                  :data-vv-as="$t('Number')"
                  :placeholder="$t('Number')"
                  inputClasses="dialer_number"
                  @onInput="onInput"
                ></vue-tel-input>
              </div>
              <div class="vx-col mt-5 ml-3 w-1/4">
                <vs-button
                  radius
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-phone"
                  icon-after
                  :disabled="btnDisabled"
                  @click.prevent="submitForm"
                ></vs-button>
              </div>
            </div>
            <div class="vx-col mt-2 ml-6 w-1/2 text-danger text-sm">{{error}}</div>
          </form>
        </div>
        <div>
          <div class="vx-row" v-show="joinedList.length > 0">
            <div
              class="vx-col w-full mt-10"
              v-for="(participate,index) in joinedList"
              :key="index"
              v-show="joinedList.length == 1 && participate.displayName !== ''"
            >
              <div class="relative">
                <div class="pointer-events-none">
                  <vs-avatar class="user-profile-img img-center" :src="profile_image" size="100px" />
                </div>
                <div class="company-center mt-5">
                  <p>{{participate.displayName}}</p>
                  <p>{{timer[participate.id]}}</p>
                </div>
                <div class="company-welcome-msg ml-20 mt-2 controllers">
                  <div class="vx-row">
                    <div class="vx-col w-1/4 ml-16">
                      <img src="@/assets/fonts/mute2.png" height="50" @click="muteCall()" />
                    </div>
                    <div class="vx-col w-1/4">
                      <img src="@/assets/fonts/hang1.png" height="50" @click="hangUp(participate.id)"/>
                    </div>
                    <div class="vx-col w-1/4">
                      <img src="@/assets/fonts/rec2.png" height="50" @click="recordCall()" style="opacity: 0.6;"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="joinedList.length > 1" class="ml-4 mt-5">
              <h5>Participant(s) :</h5>
              <vs-table pagination :data="joinedList" :max-items="6" class="mt-1">
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td width="10%">
                      <vs-avatar class="user-profile-img img-center" :src="profile_image" size="30px"/>
                    </vs-td>
                    <vs-td width="40%" :data="data[indextr].displayName">{{data[indextr].displayName}}</vs-td>
                    <vs-td width="10%">{{timer[data[indextr].id]}}</vs-td>
                    <vs-td width="50%" class="controllers">
                      <img src="@/assets/fonts/mute2.png" height="30" @click="muteCall(data[indextr].id)" />
                      <img src="@/assets/fonts/hang1.png" class="ml-2" height="30" @click="hangUp(data[indextr].id)"/>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.confroom {
  display: block; /* iframes are inline by default */
  background: rgb(179, 177, 177);
  border: none; /* Reset default border */
  height: 100vh; /* Viewport-relative units */
  width: 100vw;
}
.company-room .w-1\/2 {
  width: 71% !important;
}
.company-room .w-1\/3 {
  width: 28.33333% !important;
}
.company-room .w-1\/4 {
  width: 17% !important;
}
.vx-row > .vx-col {
  padding: 0 !important;
}
.dialer {
  background-color: #e0e0e0;
  height: 100px;
}
.vue-tel-input {
  height: 42px;
}
#profile-page .user-profile-img {
  border: none !important;
}
.img-center,
.company-center,
.company-welcome-msg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.controllers img {
  cursor: pointer;
}
.ml-4 {
    margin-left: 1.1rem !important;
}
</style>
<script>
import $ from "jquery";
import { phoneConfig } from "@/utils/helper";

export default {
  data() {
    return {
      temp: [],
      room: "",
      userInfo: {},
      showError: false,
      userId: "",
      showPayButton: false,
      uuid: "",
      bindProps: phoneConfig(this.$t("ContactNumber")),
      dialer_number: "",
      country: "",
      domain: "room.bnesim.com",
      options: {},
      api: [],
      btnDisabled: false,
      error: "",
      joinedList: [],
      counter: [],
      profile_image: require("@/assets/images/portrait/small/avatar-s-120.jpg"),
      timer: {},
      clearTimer: []
    };
  },
  mounted() {
    if (this.$store.getters.currentUser) {
      this.userId = this.$store.getters.currentUser.id;
      this.userInfo = {
        email: this.$store.getters.currentUser.email,
        displayName: "",
      };
    }
    this.room = this.$route.params.room;
    this.initConf();
  },
  methods: {
    /**
     * validate phone number
     */
    onInput({ number, isValid, country }) {
      let isJoined = false;
      this.dialer_number = number["international"];
      this.joinedList.forEach((element) => {
        if (element.displayName == this.dialer_number) {
          isJoined = true;
        }
      });
      if (isJoined == false) {
        if (this.dialer_number) {
          this.btnDisabled = false;
        } else {
          this.btnDisabled = true;
        }
        this.error = "";
      } else {
        this.error = "Already connected";
        this.btnDisabled = true;
      }
    },

    /**
     *  submitForm method for submiting form
     **/
    initConf() {
      this.options = {
        roomName: this.room,
        parentNode: document.querySelector("#meet"),
        userInfo: this.userInfo,
        configOverwrite: { startWithVideoMuted: true },
        interfaceConfigOverwrite: {
          MOBILE_APP_PROMO: true,
        },
        invitees: [],
      };
      this.api = new JitsiMeetExternalAPI(this.domain, this.options);

      // When closed
      this.api.on("readyToClose", () => {
        this.$router.push({ path: "/" });
      });

      // When user left
      this.api.on("participantLeft", (res) => {
         this.joinedList.forEach((element,index) => {
            if(element.id == res.id) {
                this.joinedList.splice(index, 1);
                this.$set(this.timer, res.id , '00:00');
                clearInterval(this.clearTimer[res.id]);
            }
        });
      });

      // When user joined
      this.api.on("participantJoined", (res) => {
        this.joinedList.push(res);
        this.$set(this.timer, res.id , '00:00');
        this.startCounter(res.id);
      });

      // When removed user
      this.api.on("participantKickedOut", (res) => {

        this.joinedList.forEach((element,index) => {
            if(element.id == res.kicked.id) {
                this.joinedList.splice(index, 1);
                this.$set(this.timer, res.kicked.id , '00:00');
                clearInterval(this.clearTimer[res.kicked.id]);
            }
        });
        
        // if no user left close video and redirect to dashboard
        if (this.joinedList.length <= 0) {
          this.api.executeCommand("hangup");
          this.$router.push({ path: "/" });
        }
      });
    },
    /**
     * connect to call
     */
    submitForm() {
      if (this.error == "") {
        this.options.invitees = [];
        let arr = {
          type: "phone",
          number: this.dialer_number,
        };

        this.options.invitees.push(arr);
        this.api
          .invite(this.options.invitees)
          .then(function () {})
          .catch(function (error) {
            console.log(error);
          });
        // dispable button
        setTimeout(() => {
          this.dialer_number = "";
          this.btnDisabled = true;
        }, 1000);
      }
    },
    /**
     * remove user
     */
    hangUp(id) {
      this.api.kick(id);
    },
    /**
     * Record call
     */
    recordCall() {
      console.log('startRecording');
      this.api.executeCommand("startRecording", {
        mode: String,
        shouldShare: true,
      });
    },
    /**
     * mute user
     */
    muteCall() {
      this.api.executeCommand("toggleAudio");
    },
    /**
     * start counter
     */
     startCounter(index) {
      var totalSeconds = 0;
      var secondsLabel = 0
      var minutesLabel = 0;
      this.clearTimer[index] = setInterval(() => {
        this.$set(this.timer, index , setTime());
        this.$forceUpdate();
      console.log('------------>', this.timer);
      }, 1000);

      function setTime() {
        ++totalSeconds;
         secondsLabel = pad(totalSeconds % 60);
         minutesLabel = pad(parseInt(totalSeconds / 60));
         return minutesLabel + ':' + secondsLabel;
      }

      function pad(val) {
        var valString = val + "";
        if (valString.length < 2) {
          return "0" + valString;
        } else {
          return valString;
        }
      }
     }
  },
};
</script>